import { ECexName } from 'web3';

export interface ICex {
  description: string;
  cex: ECexName;
  supports_pair_creation?: boolean;
  supports_accounts?: boolean;
}

export const canCreatePair = (cex: ICex): boolean => cex.supports_pair_creation !== false;

export const canCreateAccount = (cex: ICex): boolean => cex.supports_accounts !== false;
